export default __webpack_public_path__ + "static/media/message.c315ce57.wav";